import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class VrmAnimAttribute extends AbstractBlock {
  constructor() {
    super('vrm_anim_att', t.to('VRMアニメーション', 'vrm_anim'));
  }
  public SRC_FIELD_NAME = 'src';

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);
    ShapeSettings.setTitleField(block, this.title);

    const path = new Blockly.FieldTextInput('');
    block.appendDummyInput().appendField('').appendField(path, this.SRC_FIELD_NAME);

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const path = CodeSetting.getFieldValue(block, this.SRC_FIELD_NAME);
    const format = path.split('.').reverse()[0];

    const str = CodeSetting.buildAttribute(
      [['vrm-anim', `src:${path};format:${format};`]],
      attribute
    );
    return [str];
  }
}
